export const OTHER_BUCKET_LABEL = 'Other';

export const isEmptyCompositionBucket = (
  rowId: number | string | null | undefined
): boolean => rowId === 0 || rowId === '0';

export const isOtherCompositionBucket = (
  rowId: number | string | null | undefined
): boolean => rowId === -1 || rowId === '-1';

export const isEmptyCompositionSegment = (segment: {
  dim: string;
  id?: string | null;
}): boolean => {
  if (segment.id === '0') return true;
  const normalizedDim = segment.dim.trim().toLowerCase();
  if (normalizedDim === 'empty') return true;
  if (segment.dim.trim() === '') return true;
  return false;
};
